const public_api_url = process.env.REACT_APP_API_URL;

export const getTotalNumbers = () => {
  return fetch(public_api_url+"/api/totalnumbers")
    .then(res => res.json() )
}



// WEBPACK FOOTER //
// ./src/api/public/totalNumbers.js